import { Controller } from "@hotwired/stimulus"

// Botón genérico para copiar un texto al portapapeles.
// Uso: <button data-controller="clipboard" data-clipboard-text-value="..." data-action="clipboard#copy">
export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const text = this.textValue
    if (!text) return

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => this.showCopied())
        .catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
      this.showCopied()
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showCopied() {
    const icon = this.element.querySelector("i")
    if (!icon) return

    const originalClass = icon.className
    icon.className = "fas fa-check text-success"
    setTimeout(() => { icon.className = originalClass }, 1500)
  }
}
